import React, { Component } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class RoomList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      list: [],
      // user: {},
      // updated: false,
      // searched: false,
      loading: true
    };

    this.error = this.error.bind(this);
    this.insertRoom = this.insertRoom.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  insertRoom() {
    this.props.history.push("/room/form");
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    this.handleRooms();
  }

  handleRooms() {
    let requestRoute;
    if (this.props.general.active_roles.role_id === 4) {
      // Adm escolar
      requestRoute = `${URL.api}community/room/list?class=false&school[]=${this.props.general.active_roles.school_id}&user=${this.props.user.user.id}`;
    } else if (this.props.general.active_roles.role_id === 2) {
      // Adm de grupo
      requestRoute = `${URL.api}community/room/list?class=false&group[]=${this.props.general.active_roles.group_id}&user=${this.props.user.user.id}`;
    } else if (this.props.general.active_roles.role_id === 3) {
      // Adm regional
      requestRoute = `${URL.api}community/room/list?class=false&region[]=${this.props.general.active_roles.region_id}&user=${this.props.user.user.id}`;
    } else if (this.props.general.active_roles.role_id === 1) {
      // Adm Educandus
      requestRoute = `${URL.api}community/room/list?class=false&user=${this.props.user.user.id}`;
    } else {
      // Demais usuários
      requestRoute = `${URL.api}community/room/listByUser?class=false&user=${this.props.user.user.id}`;
    }

    axios
      .get(requestRoute, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState(
            () => ({
              list: null
            }),
            () => {
              if (resp.data.data.length === 0) {
                this.setState(() => ({
                  list: [],
                  loading: false
                }));
              } else {
                this.setState(
                  () => ({
                    list: resp.data.data.map(item => ({
                      ...item,
                      type:
                        item.type === "closed"
                          ? "Fechada"
                          : item.type === "semi"
                          ? "Semi-aberta"
                          : "Aberta"
                    })),
                    loading: false
                  }),
                  () => {
                    this.forceUpdate();
                  }
                );
              }
            }
          );
        },
        error => {
          this.error("Não foi possível listar as comunidades");
        }
      );
  }

  deleteRooms(rows) {
    const obj = {
      rooms: rows
    };

    axios
      .post(`${URL.api}community/room/deleteMany`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.handleRooms();
        },
        () => {
          this.error("Não foi possível apagar os usuários");
        }
      );
  }

  render() {
    return (
      <div className="animated fadeIn">
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <Row>
            <Breadcrumb current={this.props.currentRoute} />
            {this.state.list ? (
              <div id="list">
                <DataTable
                  list={this.state.list}
                  path="/room/edit/"
                  title="Comunidades"
                  header={[
                    { name: "id", denomination: "ID" },
                    { name: "name", denomination: "Nome" },
                    { name: "type", denomination: "Tipo" }
                  ]}
                  action
                  membersPath="/room/members/"
                  btnMembers
                  btnEdit
                  insert
                  delete
                  insertAction={this.insertRoom}
                  deleteAction={ids => this.deleteRooms(ids)}
                />
              </div>
            ) : (
              <Loading />
            )}
          </Row>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(RoomList);
